module.exports = __webpack_public_path__ + "img/sub_page_communication38.dc73d648.png";